import { render, staticRenderFns } from "./settleTable.vue?vue&type=template&id=68968eac&scoped=true"
import script from "./settleTable.vue?vue&type=script&lang=js"
export * from "./settleTable.vue?vue&type=script&lang=js"
import style0 from "./settleTable.vue?vue&type=style&index=0&id=68968eac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68968eac",
  null
  
)

export default component.exports